import Axios from 'axios';
export const resource = {
    state: {
        currentResource: {},
        currentPDF: {},
        currentResources: [],
        resourcePaginationIndex: 0
    },
    mutations: {
        // currentResourece
        SET_CURRENT_RESOURCE(state: any, payload: any) {
            state.currentResource = payload;
        },
        RESET_CURRENT_RESOURCE(state: any) {
            state.currentResource = {};
        },
        // currentPDF
        SET_CURRENT_PDF(state: any, payload: any) {
            state.currentPDF = payload;
        },
        RESET_CURRENT_PDF(state: any) {
            state.currentPDF = {};
        },
        // currentResources
        SET_CURRENT_RESOURCES(state: any, payload: any) {
            state.currentResources = payload;
            console.info("SETEANDO CURRENT-RESOURCES", payload);
        },
        RESET_CURRENT_RESOURCES(state: any) {
            state.currentResources = [];
        },
        // resourcePaginationIndex
        SET_RESOURCE_PAGINATION_INDEX(state: any, payload: number) {
            state.resourcePaginationIndex = payload
        },
        RESET_RESOURCE_PAGINATION_INDEX(state: any) {
            state.resourcePaginationIndex = 0
        },
    },
    actions: {
        actionSetCurrentResource(context: any, payload: any) {
            console.info("SETEANDO RECURSO", payload);
            context.commit("SET_CURRENT_RESOURCE", payload);
        },
        actionResetCurrentResource(context: any) {
            context.commit("RESET_CURRENT_RESOURCE");
        },

        async actionGetPdf(context: any, payload: any) {
            try {
                const response = await Axios.get(`${process.env.VUE_APP_ROMA_PLANNER_API_URL}file/dowload/${payload.resourcesId}`, {
                    responseType: 'blob'
                })

                const url = window.URL.createObjectURL(new Blob([response.data]))
                
                console.info("Response get pdf", url);
                
                // const blob = new Blob([response.data],{ type: 'application/pdf'});
                // context.commit("SET_CURRENT_PDF", blob);

            } catch (error) {
                console.info("Error Peticion PDF", error)
            }

            console.info("SETEANDO PDF", payload);
            context.commit("SET_CURRENT_PDF", payload);
        },
        actionResetCurrentPDF(context: any) {
            context.commit("RESET_CURRENT_PDF");
        },

        // currentResources
        actionSetCurrentResources(context: any, payload: any) {
            context.commit("SET_CURRENT_RESOURCES", payload);
        },
        actionResetCurrentResources(context: any) {
            context.commit("RESET_CURRENT_RESOURCES");
        },

        // resourcePaginationIndex
        actionSetResourcePaginationIndex(context: any, payload: number) {
            context.commit("SET_RESOURCE_PAGINATION_INDEX", payload);
            console.info("SET RESOURCE PAGINATION INDEX", payload);
        },

        actionResetResourcePaginationIndex(context: any) {
            context.commit("RESET_RESOURCE_PAGINATION_INDEX");
            console.info("RESET RESOURCE PAGINATION INDEX");
        },
    },
    getters: {
        getCurrentResource(state: any) {
            return state.currentResource;
        },
        getCurrentResources(state: any) {
            return state.currentResources;
        },
        getResourcePaginationIndex(state: any) {
            return state.resourcePaginationIndex;
        }
    }
}